"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IocModule = exports.inject5 = exports.inject4 = exports.inject3 = exports.inject2 = exports.inject = void 0;
const ferrum_plumbing_1 = require("ferrum-plumbing");
function injectMany(...args) {
    return args.map(t => IocModule.container().get(t));
}
function inject(...args) {
    return injectMany(...args)[0];
}
exports.inject = inject;
function inject2(...args) {
    return injectMany(...args);
}
exports.inject2 = inject2;
function inject3(...args) {
    return injectMany(...args);
}
exports.inject3 = inject3;
function inject4(...args) {
    return injectMany(...args);
}
exports.inject4 = inject4;
function inject5(...args) {
    return injectMany(...args);
}
exports.inject5 = inject5;
class IocModule {
    static async init() {
        if (!!IocModule._container) {
            return IocModule._container;
        }
        const c = new ferrum_plumbing_1.Container();
        IocModule._container = c;
        return c;
    }
    static container() {
        return IocModule._container;
    }
}
exports.IocModule = IocModule;
//# sourceMappingURL=IocModule.js.map